export default "__VITE_ASSET__BOCquvL9__"